// extracted by mini-css-extract-plugin
export default {"add_user_btn":"AddAuthUser_add_user_btn__9zMO6"};